<template>
  <div id="scrollTopBtn" class="container">
    <a @click="scrollTop" v-show="visible" class="btn btn-light bottom-right">
        <font-awesome-icon :icon="['fas', 'angle-double-up']" size="3x" />
    </a>
  </div>
</template>

<script>
export default {
  data () {
    return {
      visible: false
    }
  },
  methods: {
    scrollTop: function () {
      window.scrollTo(0,0);
    },
    scrollListener: function () {
      this.visible = window.scrollY > 150
    }
  },
  mounted: function () {
    window.addEventListener('scroll', this.scrollListener)
  },
  beforeUnmount: function () {
    window.removeEventListener('scroll', this.scrollListener)
  }
}
</script>

<style scoped>
/*
 * A washed black (rgba(0,0,0,.1)) gave a faint grey button on a light page and nothing at all on a dark
 * one — black on near-black. It floats over content in both themes, so it needs a surface of its own
 * rather than a tint of whatever happens to be under it.
 */
.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: 0;
  border-radius: 10px;
  background-color: var(--bo-surface, var(--bo-surface));
  border: 1px solid var(--bo-line, var(--bo-line));
  color: var(--bo-ink, var(--bo-ink));
  /* It lifts off the page, which is also what tells you it is not part of it. */
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.18);
  transition: background-color .2s ease, transform .2s ease;
}

.btn:hover {
  background-color: var(--bo-surface-2, var(--bo-surface-2));
  color: var(--bo-ink, var(--bo-ink));
  transform: translateY(-2px);
}

/* 3x was taller than the button it sits in. */
.btn :deep(svg) { font-size: 1.4rem; }

.bottom-right {
  position: fixed;
  bottom: 60px;
  right: 10px;
  cursor: pointer;
  z-index: 1030;   /* over page content, under Bootstrap's modals at 1055 */
}
</style>

